import * as React from "react";
import {
  Button,
  DialogActions,
  Dialog,
  DialogContent,
  DialogTitle,
  TextField,
  Stack,
  MenuItem,
} from "@mui/material";
import PropTypes from "prop-types";

const SolicitarElementos = (props) => {
  const { open, elementos, onClose, onSave } = props;

  const [grupos, setGrupos] = React.useState([]);
  const [grupo, setGrupo] = React.useState("");
  const [list, setList] = React.useState([]);
  const [elemento, setElemento] = React.useState("");
  const [motivo, setMotivo] = React.useState("");
  const [obs, setObs] = React.useState("");

  React.useEffect(() => {
    setGrupos([...new Set(elementos.map((e) => e.Grupo))]);
  }, [elementos]);
  React.useEffect(() => {
    setList(grupo && elementos.filter((x) => x.Grupo === grupo));
    setElemento("");
  }, [grupo]);
  React.useEffect(() => {
    if (open) {
      setGrupo("");
      setElemento("");
      setMotivo("");
      setObs("");
    }
  }, [open]);
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Nueva solicitud</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ pt: 1 }}>
          <TextField
            label="Elemento"
            size="small"
            autoFocus
            select
            value={grupo}
            onChange={(e) => setGrupo(e.target.value)}
          >
            {grupos &&
              grupos.length > 0 &&
              grupos.map((g) => (
                <MenuItem key={g} value={g}>
                  {g}
                </MenuItem>
              ))}
          </TextField>
          {grupo && (
            <TextField
              size="small"
              select
              value={elemento}
              onChange={(e) => setElemento(e.target.value)}
            >
              {list &&
                list.length > 0 &&
                list.map((e) => (
                  <MenuItem key={e} value={e}>
                    {e.Descripcion}
                  </MenuItem>
                ))}
            </TextField>
          )}
          <TextField
            label="Observación"
            size="small"
            multiline
            rows={2}
            value={obs}
            onChange={(e) => setObs(e.target.value)}
          />
          <TextField
            label="Motivo"
            size="small"
            multiline
            rows={2}
            value={motivo}
            onChange={(e) => setMotivo(e.target.value)}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button
          disabled={!elemento}
          onClick={() =>
            onSave({ elemento: elemento, observaciones: obs, motivo: motivo })
          }
        >
          Solicitar
        </Button>
        <Button onClick={onClose}>Cancelar</Button>
      </DialogActions>
    </Dialog>
  );
};
SolicitarElementos.propTypes = {
  open: PropTypes.bool.isRequired,
  elementos: PropTypes.array,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
};
export default SolicitarElementos;
